import { formTransformer } from 'utils';

export const competitionToFormTransformer = competition => {
    if (! competition) {
        return null;
    }

    return {...formTransformer(competition, ['location', 'rule', 'secretary', 'fee', 'discipline'])};
}
